// extracted by mini-css-extract-plugin
module.exports = {"main":"notificationwrite_main__aBYLC","mainTitle":"notificationwrite_mainTitle__2AgsJ"};